import preval from 'preval.macro';

export const PHONE_REG_EXP = /^\d{10}$/;

export const APP_VERSION = process.env.REACT_APP_VERSION
  ? `(${process.env.REACT_APP_VERSION})`
  : '';

export const BASE_API_URL = process.env.REACT_APP_API_URL;
export const BASE_STORAGE_URL = process.env.REACT_APP_STORAGE_URL;

export const BUILD_DATE_TIMESTAMP = preval`module.exports = new Date().toLocaleString();`;

export const LOCAL_STORAGE_KEY = {
  SWITCH_SERVER_DOMAIN: 'SWITCH_SERVER_DOMAIN',
};
